const scrollToRef = (ref, options = { behavior: "smooth", block: "start" }) => {
  if (ref && ref.current) {
    ref.current.scrollIntoView(options);
  } else if (ref && document.getElementById(ref)) {
    document.getElementById(ref).scrollIntoView(options);
  } else if (document.contains(ref)) {
    ref.scrollIntoView(options);
  }
};

export default scrollToRef;
